import React, { useState, useRef, useEffect, ReactNode } from "react";

interface MapInteractionShieldProps {
    children: ReactNode;
    className?: string;
}

export function MapInteractionShield({ children, className = "" }: MapInteractionShieldProps) {
    const [isMapLocked, setIsMapLocked] = useState(true);
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        function handleClickOutside(event: MouseEvent | TouchEvent) {
            if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
                setIsMapLocked(true);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener("touchstart", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("touchstart", handleClickOutside);
        };
    }, []);

    return (
        <div
            ref={containerRef}
            className={`relative w-full h-full ${className}`}
        >
            {isMapLocked && (
                <div
                    className="absolute inset-0 z-[2000] cursor-pointer"
                    style={{ opacity: 0 }}
                    onClick={() => setIsMapLocked(false)}
                    onTouchStart={() => setIsMapLocked(false)}
                    title="Klik op de kaart om te verplaatsen of in te zoomen"
                />
            )}
            {children}
        </div>
    );
}
